import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../app.state';
import { selectUrlParams } from '../../../url-params/url-params.selector';
import { UrlParams } from '../../../url-params/model/url-params.model';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../app.globals';
import { DeviceCheckerService } from '../../services/device-checker.service';

@Component({
    selector: 'ssf-calendar-picker',
    template: require('./calendar-picker.component.html'),
    styles: [require('./calendar-picker.component.scss')]
})
/**
 * Serves as a wrapper for ngx-bootstrap datepicker. For more info, check https://valor-software.com/ngx-bootstrap/#/datepicker.
 */
export class CalendarPickerComponent {
    /**
     * Datepicker's config object only used to pass in a different color theme.
     */
    bsConfig: Partial<BsDatepickerConfig>;
    /**
     * Sets minimal pickable date.
     */
    minDate = new Date(Globals.calendarPicker.minDate);
    lang$: Observable<string>;
    /**
     * A place relative to the component, when calendar should be rendered. If there's not enough place, it should
     * be rendered 'somewhere safe'. This behaviour is implemented in current ngx datepicker, but isn't guaranteed.
     * can be "top" | "bottom" | "left" | "right"
     * default value: bottom
     */
    @Input() placement = 'bottom';
    @Input() initDate: Date;
    @Output() dateChanged = new EventEmitter<Date>();

    constructor(private store: Store<AppState>, private translate: TranslateService,
                public deviceService: DeviceCheckerService) {
        // Sets the theme for ngx-datepicker. For more themes check API referrence.
        this.bsConfig = Object.assign({}, {containerClass: 'theme-azure', showWeekNumbers: false});
        this.lang$ = this.store.select(selectUrlParams).map((params: UrlParams) => params.lang);
    }

    /**
     * See https://docs.google.com/spreadsheets/d/12iygt-_cakNP1VO7MV9g4lq9NsxVWG4tSfc98HpHb0k/edit#gid=0
     * @return {string} date format
     */
    getDateFormat(): string {
        return this.translate.instant('FORMATS.DATE');
    }

    /**
     * Propagates event from ngx-datepicker into parrent component.
     */
    bsValueChange(date: Date) {
        this.initDate = date;
        this.dateChanged.emit(date);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/components/calendar-picker/calendar-picker.component.ts